module.exports = __webpack_public_path__ + "img/HAKAS.0412b1a8.png";